/**
 * Fixed toast viewport — bottom-right so feedback stays visible while scrolling.
 */

import React from 'react'
import { X } from 'lucide-react'
import { useToast } from '../../contexts/ToastContext'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'

const TYPE_STYLES = {
  success: 'hub-toast-success border-green-200 bg-green-50 text-green-900',
  error: 'hub-toast-error border-destructive/30 bg-destructive/10 text-destructive',
  info: 'hub-toast-info border-border bg-card text-card-foreground',
}

export default function HubToaster() {
  const { toasts, dismiss } = useToast()

  if (toasts.length === 0) return null

  return (
    <div
      className="pointer-events-none fixed bottom-[max(1rem,env(safe-area-inset-bottom,0px))] right-4 z-[200] flex w-[min(100vw-2rem,22rem)] flex-col gap-2 sm:bottom-[max(1.5rem,env(safe-area-inset-bottom,0px))] sm:right-6"
      aria-live="polite"
      aria-relevant="additions"
    >
      {toasts.map((item) => (
        <div
          key={item.id}
          role={item.type === 'error' ? 'alert' : 'status'}
          className={cn(
            'pointer-events-auto flex items-start gap-3 rounded-lg border px-4 py-3 text-sm shadow-lg',
            TYPE_STYLES[item.type] || TYPE_STYLES.info
          )}
        >
          <p className="min-w-0 flex-1 leading-snug">{item.message}</p>
          <Button
            type="button"
            variant="ghost"
            size="icon"
            className="h-7 w-7 shrink-0 text-current/60 hover:text-current"
            onClick={() => dismiss(item.id)}
            aria-label="Dismiss notification"
          >
            <X className="h-4 w-4" />
          </Button>
        </div>
      ))}
    </div>
  )
}
